/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SearchClientType = {
    IOS: 'IOS',
    ANDROID: 'ANDROID',
    WEB: 'WEB',
    unknown_default_open_api: '11184809'
} as const;
export type SearchClientType = typeof SearchClientType[keyof typeof SearchClientType];


export function instanceOfSearchClientType(value: any): boolean {
    for (const key in SearchClientType) {
        if (Object.prototype.hasOwnProperty.call(SearchClientType, key)) {
            if (SearchClientType[key as keyof typeof SearchClientType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SearchClientTypeFromJSON(json: any): SearchClientType {
    return SearchClientTypeFromJSONTyped(json, false);
}

export function SearchClientTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchClientType {
    return json as SearchClientType;
}

export function SearchClientTypeToJSON(value?: SearchClientType | null): any {
    return value as any;
}

